import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Grid, FormDialog, TextField, Typography, FormControl, InputLabel, Select, MenuItem, Divider, useMediaQuery, useTheme, } from "../../mui";
import { UserPermission, userRole, userStatus } from "../../../utils/enums";
import { ContentActions, ContentTypography, getContent } from "../../common/content";
import { EDIT_USER } from "./Personal";
import constants from "../../../utils/constants";
import defaults from "../../../utils/defaults";
import { newTeamMember } from "../../../utils/auth/graph_helper";
const ADD_USER = gql `
  mutation AddUser($data: userInput!) {
    addUser(data: $data) {
      id
    }
  }
`;
const ManageUserDialog = ({ organizationId = null, data = null, actionDialogState = null, setActionDialogState = () => null, setSnackBar = () => null, }) => {
    const userId = localStorage.getItem("userId") || null;
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down("sm"));
    const [user, setUser] = React.useState(defaults.users);
    React.useEffect(() => {
        setUser(data || defaults.users);
    }, [data]);
    const [addUser] = useMutation(ADD_USER, {
        refetchQueries: ["Team"],
    });
    const [editUser] = useMutation(EDIT_USER, {
        refetchQueries: ["Team"],
    });
    const onUserSave = async () => {
        const { email, password } = user;
        let data = null;
        if (actionDialogState.action === constants.OPERATION_TYPE.ADD) {
            const result = await newTeamMember(email, password);
            if (result?.status === "success") {
                data = {
                    ...user,
                    organizationId,
                    passwordRequestFlag: true,
                    status: userStatus.Invited,
                    cognitoUserId: result?.user?.storage?.userId,
                };
                delete data?.password;
                delete data?.permissions;
                delete data?.avatar;
                addUser({
                    variables: { data },
                    onCompleted: () => setSnackBar({
                        open: true,
                        message: `Added Team Member Successfully!`,
                        type: "success",
                    }),
                    onError: () => setSnackBar({
                        open: true,
                        message: `${getContent("errorMessage")}`,
                        type: "error",
                    }),
                });
            }
        }
        if (actionDialogState.action === constants.OPERATION_TYPE.EDIT) {
            data = { ...user };
            const id = data.id;
            delete data?.id;
            delete data?.createdAt;
            delete data?.password;
            delete data?.__typename;
            data.permissions =
                data?.permissions?.map((permission) => ({
                    id: permission.id,
                    permission: permission.permission,
                    feature: permission.feature,
                })) || [];
            editUser({
                variables: { id, data },
                onCompleted: () => setSnackBar({
                    open: true,
                    message: `Updated Team Member Successfully!`,
                    type: "success",
                }),
                onError: () => setSnackBar({
                    open: true,
                    message: `${getContent("errorMessage")}`,
                    type: "error",
                }),
            });
        }
        setActionDialogState({
            open: false,
            id: null,
            action: null,
        });
    };
    const onUserEdit = (event) => {
        let temp = { ...user };
        if (event.target.name === "selected") {
            temp.selected = event.target.checked;
        }
        else {
            temp[event.target.name] = event.target.value;
        }
        if (event.target.name === "role" && event.target.value === userRole.Admin) {
            temp.permissions = user?.permissions?.map((permission) => ({
                ...permission,
                permission: UserPermission.Manage,
            }));
        }
        setUser(temp);
    };
    return (_jsx(FormDialog, { open: actionDialogState?.open || false, setOpen: () => setActionDialogState({
            open: false,
            id: null,
            action: null,
        }), title: `${actionDialogState.action} ${getContent("teamMember")}`, actions: _jsx(ContentActions, { onClose: () => setActionDialogState({
                open: false,
                id: null,
                action: null,
            }), onSave: onUserSave }), children: _jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, spacing: 4, children: [_jsx(Grid, { item: true, xs: smMatches ? 12 : 6, children: _jsx(TextField, { fullWidth: true, label: getContent("emailLabel"), name: "email", value: user?.email, onChange: onUserEdit, disabled: actionDialogState.action === constants.OPERATION_TYPE.EDIT, size: "small" }) }), actionDialogState.action === constants.OPERATION_TYPE.ADD && (_jsx(Grid, { item: true, xs: smMatches ? 12 : 6, children: _jsx(TextField, { fullWidth: true, label: getContent("defaultPassword"), type: "password", name: "password", onChange: onUserEdit, size: "small" }) })), _jsx(Grid, { item: true, xs: smMatches ? 12 : 6, children: _jsx(TextField, { fullWidth: true, name: "firstName", value: user?.firstName || "", label: getContent("firstNameLabel"), onChange: onUserEdit, size: "small" }) }), _jsx(Grid, { item: true, xs: smMatches ? 12 : 6, children: _jsx(TextField, { fullWidth: true, name: "lastName", value: user?.lastName || "", label: getContent("lastNameLabel"), onChange: onUserEdit, size: "small" }) }), _jsx(Grid, { item: true, xs: smMatches ? 12 : 6, children: _jsxs(FormControl, { style: { width: "100%" }, children: [_jsx(InputLabel, { children: getContent("roleLabel") }), _jsx(Select, { fullWidth: true, name: "role", value: user?.role, label: getContent("selectRoleLabel"), onChange: onUserEdit, size: "small", disabled: userId === actionDialogState?.id, children: [userRole.Admin, userRole.Employee, userRole.Client, userRole.Vendor]?.map((type, index) => (_jsx(MenuItem, { value: userRole[type], children: type }, index))) })] }) }), _jsx(Grid, { item: true, xs: smMatches ? 12 : 6, children: _jsx(TextField, { fullWidth: true, name: "jobTitle", value: user?.jobTitle || "", label: getContent("jobTitleLabel"), onChange: onUserEdit, size: "small" }) })] }), user?.permissions?.length > 0 && (_jsxs(Grid, { container: true, spacing: 4, sx: { pt: 4 }, children: [_jsxs(Grid, { item: true, xs: 12, children: [_jsx(ContentTypography, { color: "primary", variant: "subtitle2", fontWeight: "bold", field: "permissionsLabel" }), _jsx(Divider, { flexItem: true })] }), _jsx(Grid, { item: true, xs: 12, children: user?.permissions?.map((permission, index) => (_jsxs(Grid, { container: true, spacing: 2, m: 1, children: [_jsx(Grid, { item: true, xs: smMatches ? 6 : 3, children: _jsxs(Typography, { mt: 2, sx: { fontWeight: "bold" }, children: [permission?.feature, ":"] }) }), _jsx(Grid, { item: true, xs: smMatches ? 6 : 3, children: _jsx(FormControl, { style: { width: "100%" }, children: _jsx(Select, { fullWidth: true, name: "permission", value: permission?.permission, size: "small", onChange: (event) => {
                                                    const value = [
                                                        ...user?.permissions?.slice(0, index),
                                                        {
                                                            ...permission,
                                                            permission: event.target.value,
                                                        },
                                                        ...user?.permissions?.slice(index + 1, user?.permissions?.length),
                                                    ];
                                                    onUserEdit({
                                                        target: {
                                                            name: "permissions",
                                                            value,
                                                        },
                                                    });
                                                }, disabled: userId === actionDialogState?.id, children: Object?.keys(UserPermission)?.map((type, index) => (_jsx(MenuItem, { value: UserPermission[type], children: type }, index))) }) }) })] }, index))) })] }))] }) }));
};
export default ManageUserDialog;
